export interface MemedPatientProfile {
  id: string;
  name?: string | null;
  gender?: string | null;
  cpf?: string | null;
  birthDate?: Date | string | null;
  phone?: string | null;
  email?: string | null;
  recordNumber?: string | null;
  healthProfile?: {
    weight?: number | null;
    height?: number | null;
  } | null;
}

export interface MemedDoctorInfo {
  name?: string | null;
  crm?: string | null;
  crmState?: string | null;
}

export interface MemedAdditionalDataPayload {
  header: Array<Record<string, string>>;
}

function formatDate(date: Date | string | null | undefined): string | undefined {
  if (!date) return undefined;
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return undefined;
  return d.toLocaleDateString('pt-BR');
}

function mapGender(gender: string | null | undefined): string | undefined {
  if (!gender) return undefined;
  const normalized = gender.toLowerCase();
  if (normalized === 'male' || normalized === 'm') return 'Masculino';
  if (normalized === 'female' || normalized === 'f') return 'Feminino';
  return gender;
}

function toShortId(id: string): string | undefined {
  const normalized = id.trim();
  if (!normalized) return undefined;
  return normalized.split('-')[0] || normalized;
}

function buildProfessionalValue(doctor: MemedDoctorInfo): string {
  const name = doctor.name?.trim();
  if (!name) return '';
  const crm = doctor.crm?.trim();
  if (!crm) return name;
  const crmState = doctor.crmState?.trim() || '';
  return `${name} (CRM: ${crm}${crmState})`;
}

export function buildMemedAdditionalData(
  patient: MemedPatientProfile,
  doctor?: MemedDoctorInfo
): MemedAdditionalDataPayload {
  const header: Array<Record<string, string>> = [];

  const recordNumber = patient.recordNumber?.trim() || toShortId(patient.id);
  if (recordNumber) {
    header.push({ Registro: recordNumber });
  }

  const demographic: Record<string, string> = {};
  const gender = mapGender(patient.gender);
  if (gender) {
    demographic['Sexo'] = gender;
  }
  const birthDate = formatDate(patient.birthDate);
  if (birthDate) {
    demographic['Data de Nasc'] = birthDate;
  }
  if (Object.keys(demographic).length > 0) {
    header.push(demographic);
  }

  const professional = doctor ? buildProfessionalValue(doctor) : '';
  if (professional) {
    header.push({ Profissional: professional });
  }

  return { header };
}
